<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout(raw wrap)

                v-flex(xs12)

                    // Package type selection
                    v-select(
                        name="packageType"
                        append-icon="expand_more"
                        outline
                        v-model="package"
                        :items="$t('selection.packagesNoTrial')"
                        :label="$t('fields.packageType')"
                    )

                v-flex(xs12)

                    // Business information block title
                    title-component(
                        type="h4"
                        :title="$t('payments.payment.subtitle')"
                    )

                v-flex(xs12)

                    // Card number
                    v-text-field(
                        :error-messages="errors.collect('cardNumber')"
                        :data-vv-as="$t('fields.cardNumber')"
                        :label="$t('fields.cardNumber')"
                        append-icon="credit_card"
                        name="cardNumber"
                        mask="credit-card"
                        v-model.lazy="model.number"
                        v-validate="'required|credit_card'"
                        outline
                    )

                v-flex(xs4)

                    // Month expiration
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('exp_month')"
                        :data-vv-as="$t('fields.monthExp')"
                        label="MM"
                        name="exp_month"
                        mask="##"
                        v-model.lazy="model.exp_month"
                        v-validate="'required|min:2|max:2|min_value:1|max_value:12'"
                        outline
                    )

                v-flex(xs4)

                    // Month expiration
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('exp_year')"
                        :data-vv-as="$t('fields.yearExp')"
                        label="YY"
                        name="exp_year"
                        mask="##"
                        v-model.lazy="model.exp_year"
                        v-validate="'required|min:2|min_value:20|max_value:99'"
                        outline
                    )

                v-flex(xs4)

                    // CVV
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('CVV')"
                        :data-vv-as="$t('fields.CVV')"
                        :label="$t('fields.CVV')"
                        name="CVV"
                        v-model.lazy="model.cvc"
                        v-validate="'required|numeric|min:3|max:4'"
                        outline
                    )

                v-flex(xs12)

                    // Coupon code block title
                    title-component(
                        type="h4"
                        :title="$t('payments.payment.subtitleCoupon')"
                    )

                v-flex(xs12)

                    // Coupon Code
                    v-text-field(
                        :error-messages="errors.collect('coupon')"
                        :data-vv-as="$t('fields.coupon')"
                        :label="$t('fields.coupon')"
                        name="coupon"
                        v-model.lazy="coupon"
                        v-validate="'alpha_dash'"
                        outline
                    )

                v-flex(xs6 sm6)

                    // Cancel button
                    button-component.ml-0(
                        :action="goBack"
                        :isLoading="isLoading"
                        :disabled="isLoading"
                        color="grey"
                        block
                        large
                        outline
                    ) {{ $t('defaultButtons.cancel') }}

                v-flex(xs6 sm6)

                    // Submit button
                    button-component.mx-0.submit(
                        block
                        large
                        :action="submit"
                        :isLoading="isLoading"
                        color="primary"
                    ) {{ $t('defaultButtons.confirm') }}
</template>

<script>
    import Button from '~components/Button';
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            TitleComponent: Title,
            ButtonComponent: Button
        },
        data() {
            return {
                dateExp: null
            };
        },
        computed: {
            ...mapFields('payments', {
                model: 'paymentDetails',
                package: 'packageType',
                coupon: 'coupon'
            }),
            ...mapGetters('payments', ['isLoading', 'packageType'])
        },
        mounted() {
            if (this.packageType && this.package !== this.packageType) {
                this.package = this.packageType;
            }
        },
        methods: {
            ...mapActions('payments', ['createSubscription']),

            /**
             * Add card on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                // Call store action Create Business account
                this.createSubscription();
            },

            goBack() {
                this.$router.go(-1);
            }
        }
    };
</script>
